import { Fragment } from 'react';
import styled from 'styled-components';

import { theme } from '../ui/theme';

const StyledParagraph = styled.p`
    font-size: ${theme.fontSizes[14]};
    font-weight: ${theme.fontWeights[400]};
    line-height: 24px;
`;

interface MultilineParagraphProps {
    children: string;
}

export const MultilineParagraph = ({ children }: MultilineParagraphProps) => {
    const lines = children.split('\n').map((line) => {
        return line;
    });

    return (
        <StyledParagraph>
            {lines.map((line, index) => {
                if (index === lines.length - 1) {
                    return <Fragment key={index}>{line}</Fragment>;
                }

                return (
                    <Fragment key={index}>
                        {line}
                        <br />
                    </Fragment>
                );
            })}
        </StyledParagraph>
    );
};
